import React from 'react';
import PropTypes from 'prop-types';

const SmsSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 17}`}
      height={`${height || 16}`}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8335 13.6666H5.16683C3.16683 13.6666 1.8335 12.6666 1.8335 10.3333V5.66665C1.8335 3.33331 3.16683 2.33331 5.16683 2.33331H11.8335C13.8335 2.33331 15.1668 3.33331 15.1668 5.66665V10.3333C15.1668 12.6666 13.8335 13.6666 11.8335 13.6666Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8332 6L9.7465 7.66667C9.05983 8.21333 7.93317 8.21333 7.2465 7.66667L5.1665 6"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

SmsSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default SmsSvg;
